import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createRunApplicationSummitLeadThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.RunApplicationSummitLead,
    async ({ applicationId }: { applicationId: string }) => {
      const response = await api.runApplicationSummitLead(applicationId);
      return response;
    },
  );
